<template>
    <div class="popup hobcutout-selection" v-show="visible">
        <div class="content">
            <a href="" class="close icon-close" @click.prevent="close"></a>

            <h2 class="h2" v-html="ui.t('hobcutoutChoose')"></h2>

            <option-list :optionList="ui.hobcutouts"
                v-model="hubcutout"
                :itemClasses="[ 'col-6' ]"
                :withImages="true" />
        </div>
    </div>
</template>

<script async setup lang="ts">
import { computed } from 'vue';
import { useState, useUI } from '../store';
import { useRouter } from 'vue-router';

const visible = defineModel("visible", { default: false });

const emit = defineEmits(["update:visible"]);

const { state } = useState();
const { ui } = useUI();
const router = useRouter();

const hubcutout = computed({
    get() {
        return state.hubcutout;
    },
    set(value: string) {
        let hobcutoutWasNull = state.hobcutout == null;

        state.hobcutout = value;

        if (value == "0") {
            state.hobcutoutLength = null;
            state.hobcutoutWidth = null;
            state.hobcutoutDistanceY = null;
            state.hobcutoutDistanceX = null;
        }

        //Skip hobcutout step if user has chosen "no hobcutout"
        if (hobcutoutWasNull && value == "0")
            router.push(ui.functionalAreaAvailable ? `/${state.productFamily}/functional-area` : `/${state.productFamily}/accessories`);

        close();
    }
});

function close() {
    emit("update:visible", false);
}

</script>
